<template>
    <div class="page">
        <div class="header">
            <Header :current="['zt']"></Header>
            <div class="zt-title">商河县主体名录库</div>
            <div class="header-search">
                <a-input-search
                    placeholder="输入搜索内容"
                />
            </div>
        </div>
        <div class="content">
            <div class="complete" v-if="registerStatus">
                <h1>申报信息提交成功！</h1>
<!--                <p style="text-align: center; margin-top: 30px;margin-bottom: 45px">您的系统账号：133222333，密码：123456</p>-->
<!--                <p>使用以上账号即可登录系统查看您的申报审批进度，申报审批通过后，即可在系统-->
<!--                    中发布信息，请妥善保管您的系统账号！</p>-->
            </div>
            <a-form v-else :model="formState" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules" ref="formRef">
                <div class="mla-form">
                    <div class="mla-form-title"><p>基本信息</p><div></div></div>
                    <a-form-item label="主体名称" name="subjectName">
                        <a-input v-model:value="formState.subjectName"  placeholder="请输入主体名称"/>
                    </a-form-item>
                    <a-form-item label="组织类型" name="subjectType">
                        <a-select v-model:value="formState.subjectType" placeholder="请选择组织类型">
                            <a-select-option v-for="(item, i) in subjectData.subjectTypeList" :key="i" :value="item.name">{{ item.value }}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="联系人" name="contactsName">
                        <a-input v-model:value="formState.contactsName"  placeholder="请输入联系人姓名"/>
                    </a-form-item>
                    <a-form-item label="法人" name="legalPerson">
                        <a-input v-model:value="formState.legalPerson"  placeholder="请输入法人姓名"/>
                    </a-form-item>
                    <a-form-item label="所在镇街" name="TownType">
                        <a-select v-model:value="formState.TownType" placeholder="请选择所在镇街">
                            <a-select-option value="5169">孙集镇</a-select-option>
                            <a-select-option value="6148">经济开发区</a-select-option>
                            <a-select-option value="5172">张坊镇</a-select-option>
                            <a-select-option value="5165">郑路镇</a-select-option>
                            <a-select-option value="5170">韩庙镇</a-select-option>
                            <a-select-option value="5162">殷巷镇</a-select-option>
                            <a-select-option value="5167">玉皇庙镇</a-select-option>
                            <a-select-option value="5163">怀仁镇</a-select-option>
                            <a-select-option value="5164">龙桑寺镇</a-select-option>
                            <a-select-option value="6048">许商街道</a-select-option>
                            <a-select-option value="5166">贾庄镇</a-select-option>
                            <a-select-option value="5171">沙河镇</a-select-option>
                            <a-select-option value="5168">白桥镇</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="所在社区" name="address">
                        <a-input v-model:value="formState.address"  placeholder="请输入所在村居或社区"/>
                    </a-form-item>
<!--                    <a-form-item label="选取位置">-->
<!--                        <span style="cursor: pointer" @click="getLocal">{{ localText }}</span>-->
<!--                        <iframe src="https://m.amap.com/picker/?center=116.3972,39.9696&key=608d75903d29ad471362f8c58c550daf" class="iframe-style" :class="{'iframe-style-large': iframeStyle}" id="otherPage" frameborder="no" border="0" marginwidth="0" marginheight="0" scrolling="no" allowtransparency="yes"></iframe>-->
<!--                    </a-form-item>-->
                    <a-form-item label="联系电话" name="phoneCode">
                        <a-input v-model:value="formState.contactsPhone"  placeholder="请输入联系电话" style="margin-bottom: 10px"/>
                    </a-form-item>
                    <a-form-item label="验证码" name="code">
                        <a-input v-model:value="formState.code" placeholder="请输入验证码"/>
                        <img :src="imageCode" alt="" @click="changeCode" style="cursor: pointer">
                    </a-form-item>


                </div>
                <div class="mla-form">
                    <div class="mla-form-title"><p>主体情况</p><div></div></div>
                    <a-form-item label="营业执照" name="businessLicense">
                        <a-upload
                            list-type="picture-card"
                            accept="image/*"
                            :customRequest="handleUploadImage0"
                            :multiple=false
                            :remove="handleRemove0"
                        >
                            <div v-if="fileList.length < 1">
                                <PlusOutlined />
                                <div class="ant-upload-text">上传</div>
                            </div>
                        </a-upload>
                    </a-form-item>
                    <a-form-item label="法人证件（身份证）" name="businessLicense">
                        <a-upload
                            list-type="picture-card"
                            accept="image/*"
                            :customRequest="handleUploadImage1"
                            :multiple=false
                            :remove="handleRemove1"
                        >
                            <div v-if="fileList1.length < 1">
                                <PlusOutlined />
                                <div class="ant-upload-text">人像面</div>
                            </div>
                        </a-upload>
                        <a-upload
                            list-type="picture-card"
                            accept="image/*"
                            :customRequest="handleUploadImage2"
                            :multiple=false
                            :remove="handleRemove2"
                        >
                            <div v-if="fileList2.length < 1">
                                <PlusOutlined />
                                <div class="ant-upload-text">国徽面</div>
                            </div>
                        </a-upload>
                    </a-form-item>
                    <a-form-item label="服务范围" name="services">
<!--                        <a-input v-model:value="formState.services" placeholder="请输入服务范围"/>-->
                        <a-select v-model:value="formState.services" placeholder="请选择服务范围">
                            <a-select-option value="本镇">本镇</a-select-option>
                            <a-select-option value="全县">全县</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="主体介绍" name="subjectMsg">
                        <a-textarea v-model:value="formState.subjectMsg" placeholder="经营土地面积/装备数量及型号/作业能力和目前作业量" :auto-size="{ minRows: 5, maxRows: 8 }"/>
                    </a-form-item>
                    <a-form-item label="主体图片">
                        <a-upload
                            list-type="picture-card"
                            accept="image/*"
                            :customRequest="handleUploadImage3"
                            :multiple=true
                            :remove="handleRemove3"
                        >
                            <div v-if="fileList3.length < 9">
                                <PlusOutlined />
                                <div class="ant-upload-text">上传</div>
                            </div>
                        </a-upload>
                    </a-form-item>
                </div>
                <a-form-item :wrapper-col="{offset: 11 }">
                    <a-button type="primary" @click="onSubmit" size="large" class="cus-button">提交申请</a-button>
                </a-form-item>
            </a-form>
        </div>
        <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
            <img alt="example" style="width: 100%" :src="previewImage" />
        </a-modal>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/portal/Header'
import Footer from "../../components/portal/Footer"
import { reactive } from 'vue'
import {onMounted, ref} from "@vue/runtime-dom"
import {addDirectories, getSubjectType, sendPhoneCode, uploadImageApi} from "@/api/directories"
import {notification} from "ant-design-vue"
import { PlusOutlined } from '@ant-design/icons-vue'
import {utils} from '@/utils/global'
function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
    })
}
export default{
    name: "MingLuAdd",
    setup() {
        const subjectData = reactive({
            subjectTypeList: [],
        })
        const loading = reactive({
            codeLoading: false,
            codeText: '发送验证码',
            isCode: false
        })
        const formRef = ref()
        const formState = reactive({
            subjectName: undefined,
            subjectType: undefined,
            contactsName: undefined,
            legalPerson: undefined,
            TownType: undefined,
            address: undefined,
            contactsPhone: undefined,
            code: undefined,
            services: undefined,
            subjectMsg: undefined,
            // lonLats: ''
        })
        const registerStatus = ref(false)
        const fileList = ref([])
        const fileList1 = ref([])
        const fileList2 = ref([])
        const fileList3 = ref([])
        const localText = ref('点击选择位置')
        const iframeStyle = ref(false)
        const handleUploadImage0 = (params) => {
            const fd = new FormData()
            fd.append('file', params.file)
            fd.append('bizType', 1)
            uploadImageApi(fd).then(res => {
                if (res) {
                    fileList.value.push({id: res.bizId, url: res.url.split('nyfile')[1]})
                    notification.success({ message:  '上传成功！', duration: 2.5, description: '' })
                    params.onSuccess(res, params.file)
                } else {
                    notification.error({ message:  '上传失败！', duration: 2.5, description: '' })
                    params.onError()
                }
            }).catch(error => {
                console.error(error)
            })
        }
        const handleRemove0 = (file) => {
            const id = file.response.bizId
            for (const i in fileList.value) {
                if (fileList.value[i].id === id) {
                    fileList.value.splice(i,1)
                }
            }
        }
        const handleUploadImage1 = (params) => {
            const fd = new FormData()
            fd.append('file', params.file)
            fd.append('bizType', 1)
            uploadImageApi(fd).then(res => {
                if (res) {
                    fileList1.value.push({id: res.bizId, url: res.url.split('nyfile')[1]})
                    notification.success({ message:  '上传成功！', duration: 2.5, description: '' })
                    params.onSuccess(res, params.file)
                } else {
                    notification.error({ message:  '上传失败！', duration: 2.5, description: '' })
                    params.onError()
                }
            }).catch(error => {
                console.error(error)
            })
        }
        const handleRemove1 = (file) => {
            const id = file.response.bizId
            for (const i in fileList1.value) {
                if (fileList1.value[i].id === id) {
                    fileList1.value.splice(i,1)
                }
            }
        }
        const handleUploadImage2 = (params) => {
            const fd = new FormData()
            fd.append('file', params.file)
            fd.append('bizType', 1)
            uploadImageApi(fd).then(res => {
                if (res) {
                    fileList2.value.push({id: res.bizId, url: res.url.split('nyfile')[1]})
                    notification.success({ message:  '上传成功！', duration: 2.5, description: '' })
                    params.onSuccess(res, params.file)
                } else {
                    notification.error({ message:  '上传失败！', duration: 2.5, description: '' })
                    params.onError()
                }
            }).catch(error => {
                console.error(error)
            })
        }
        const handleRemove2 = (file) => {
            const id = file.response.bizId
            for (const i in fileList2.value) {
                if (fileList2.value[i].id === id) {
                    fileList2.value.splice(i,1)
                }
            }
        }
        const handleUploadImage3 = (params) => {
            const fd = new FormData()
            fd.append('file', params.file)
            fd.append('bizType', 1)
            uploadImageApi(fd).then(res => {
                if (res) {
                    fileList3.value.push({id: res.bizId, url: res.url.split('nyfile')[1]})
                    notification.success({ message:  '上传成功！', duration: 2.5, description: '' })
                    params.onSuccess(res, params.file)
                } else {
                    notification.error({ message:  '上传失败！', duration: 2.5, description: '' })
                    params.onError()
                }
            }).catch(error => {
                console.error(error)
            })
        }
        const handleRemove3 = (file) => {
            const id = file.response.bizId
            for (const i in fileList3.value) {
                if (fileList3.value[i].id === id) {
                    fileList3.value.splice(i,1)
                }
            }
        }

        const getSubjectTypes = async () => {
            // 获取主体类型
            const data = await getSubjectType()
            const list = []
            for (const n in data) {
                list.push({name: n, value: data[n]})
            }
            subjectData.subjectTypeList = list
        }
        const key = ref(utils.randomNum(24, 16))
        const imageCode = ref('http://shsn.innomesh.cn:8012/anno/captcha/?key=' + key.value)
        const changeCode = () => {
            key.value = utils.randomNum(24, 16)
            imageCode.value = 'http://shsn.innomesh.cn:8012/anno/captcha/?key=' + key.value
        }
        const checkPhone = (phone) =>{
            if(!(/^1[3456789]\d{9}$/.test(phone))){
                return false
            } else {
                return true
            }
        }
        const sendCode = () => {
            const mobileCheck = checkPhone(formState.contactsPhone)
            if (!mobileCheck) {
                notification.error({ message: '手机号格式不正确，请重新输入！', duration: 1.5, description: '' })
                return
            } else {
                let timeClock
                sendPhoneCode(formState.contactsPhone).then((res) => {
                    if (res == '发送成功') {
                        loading.codeLoading = true
                        loading.isCode = true
                        let time = 60
                        timeClock = setInterval(() => {
                            time --
                            loading.codeText = time+'秒后重试'
                            if (time == 0) {
                                clearInterval(timeClock)
                                loading.codeLoading = false
                                loading.codeText = '发送验证码'
                            }
                        }, 1000)
                    }
                })
            }
        }
        const rules = {
            subjectName: [
                {
                    required: true,
                    message: '请输入主体名称',
                    trigger: 'blur',
                },
            ],
            subjectType: [
                {
                    required: true,
                    message: '请选择组织类型',
                    trigger: 'blur',
                },
            ],
            contactsName: [{required: true,message: '请输入联系人',trigger: 'blur'}],
            legalPerson: [{required: true,message: '请输入法人',trigger: 'blur'}],
            TownType: [
                {
                    required: true,
                    message: '请选择所在镇街',
                    trigger: 'blur',
                },
            ],
            address: [{required: true,message: '请输入所在社区/村',trigger: 'blur'}],
            code: [{required: true,message: '请输入验证码',trigger: 'blur'}],
            businessLicense: [{required: false,message: '请选择',trigger: 'blur'}],
            services: [{required: true,message: '请输入营业区域',trigger: 'blur'}],
            subjectMsg: [{required: true,message: '请输入主体介绍',trigger: 'blur'}],
        }
        const previewVisible = ref(false)
        const previewImage = ref('')
        const register = async(params) => {
            const data = await addDirectories(params)
            if (data) {
                registerStatus.value = true
                notification.success({ message: '提交成功！', duration: 2.5, description: '' })
                setTimeout(() => {
                    location.reload()
                }, 2000)
            }
            // console.log(data)

        }
        const handlePreview = async file => {
            if (!file.url && !file.preview) {
                file.preview = await getBase64(file.originFileObj);
            }

            previewImage.value = file.url || file.preview;
            previewVisible.value = true;
        }
        const handleCancel = () => {
            previewVisible.value = false
        }
        const onSubmit = () => {
            // 要验证loading.isCode是否为true
            formRef.value
                .validate()
                .then(() => {
                    const mobileCheck = checkPhone(formState.contactsPhone)
                    if (!mobileCheck) {
                        notification.error({ message: '手机号格式不正确，请重新输入！', duration: 1.5, description: '' })
                        return
                    }
                    if (fileList.value.length === 0) {
                        notification.warning({ message: '请选择营业执照图片！', duration: 2.5, description: '' })
                        return
                    }
                    if (fileList1.value.length === 0) {
                        notification.warning({ message: '请选择法人身份证人像面图片！', duration: 2.5, description: '' })
                        return
                    }
                    if (fileList2.value.length === 0) {
                        notification.warning({ message: '请选择法人身份证国徽面图片！', duration: 2.5, description: '' })
                        return
                    }
                    if (fileList3.value.length === 0) {
                        notification.warning({ message: '请选择主体图片！', duration: 2.5, description: '' })
                        return
                    }
                    const businessLicense = fileList.value[0].url // 营业执照照片
                    let subjectImgs
                    if (fileList3.value.length > 0) {
                        const imgList = []
                        for (const i in fileList3.value) {
                            imgList.push(fileList3.value[i].url)
                        }
                        subjectImgs = imgList.toString() // 主体图片列表
                    }
                    let identityImgz
                    if (fileList2.value.length > 0) {
                        const imgList = []
                        for (const i in fileList2.value) {
                            imgList.push(fileList2.value[i].url)
                        }
                        identityImgz = imgList.toString() // 国徽面
                    }
                    let identityImgf
                    if (fileList1.value.length > 0) {
                        const imgList = []
                        for (const i in fileList1.value) {
                            imgList.push(fileList1.value[i].url)
                        }
                        identityImgf = imgList.toString() // 人像面
                    }
                    const params = {
                        subjectName: formState.subjectName, //主体名称
                        subjectTypes: formState.subjectType, //主体类型
                        contactsName: formState.contactsName, //联系人姓名
                        legalPerson: formState.legalPerson, //法人姓名
                        towns: formState.TownType, //所属乡镇
                        address: formState.address, //所在地址
                        contactsPhone: formState.contactsPhone, //联系人电话,
                        code: formState.code,
                        key: key.value,
                        businessLicense: businessLicense, //营业执照图片
                        services: formState.services, //服务区域
                        subjectMsg: formState.subjectMsg, //主体介绍
                        // subjectLogo: subjectLogo, //主体logo
                        subjectImgs: subjectImgs, //主体图片列表
                        identityImgf: identityImgf,
                        identityImgz: identityImgz,
                        // longitudeAndLatitude: formState.lonLats
                    }
                    console.log(params)
                    register(params)
                })
                .catch(error => {
                    console.log('error', error);
                })

            // console.log('submit!', toRaw(formState))
        }
        onMounted(() => {
            getSubjectTypes()
        })
        return {
            labelCol: {
                span: 5
            },
            wrapperCol: {
                span: 16,
                offset: 1
            },
            formState,
            loading,
            fileList,
            fileList1,
            fileList2,
            fileList3,
            subjectData,
            rules,
            previewVisible,
            previewImage,
            formRef,
            localText,
            iframeStyle,
            imageCode,
            registerStatus,
            onSubmit,
            getSubjectTypes,
            sendCode,
            checkPhone,
            register,
            handlePreview,
            handleCancel,
            changeCode,
            handleUploadImage0,
            handleRemove0,
            handleUploadImage1,
            handleRemove1,
            handleUploadImage2,
            handleRemove2,
            handleUploadImage3,
            handleRemove3,
        }
    },
    components: {
        Header,
        Footer,
        PlusOutlined,
    }
}
</script>

<style scoped lang="stylus">
    .page {
        width 100%
        height 100%
        position relative
        font-size 16px
        background-color #FFF
        .header {
            width 100%
            height 730px
            padding-top 130px
            box-shadow 0 23px 120px rgba(0, 0, 0, 0.3)
            border-bottom-left-radius 315px
            border-bottom-right-radius 315px
            background-image url("../../assets/img/portal_service_bg.png")
            background-size 100% 100%
            background-repeat no-repeat
            .zt-title {
                margin-top 200px
                width 100%
                font-size 48px
                color #FFF
                font-weight bold
                text-align center
            }
            .header-search {
                width 600px
                height 70px
                margin 60px auto 200px auto
            }
            .header-search >>> .ant-input-affix-wrapper {
                height 70px
                font-size 22px
            }
            .header-search >>> .ant-input-affix-wrapper > input.ant-input {
                border-radius 5.333vw
                font-size 18px
                padding 4px 20px
            }
            .header-search >>> .ant-input-affix-wrapper .ant-input-suffix {
                margin-right 10px
            }
        }
        .content {
            width 100%
            min-height 200px
            margin-top 40px
            padding-bottom 50px
            .complete {
                width 1320px
                padding 40px 50px 110px 50px
                box-shadow 0 9px 28px rgba(0, 0, 0, 0.05)
                background-color #FFF
                margin 0 auto
                margin-bottom 50px
            }
            .complete h1 {
                font-size 46px
                text-align center
            }
            .complete p {
                font-size 35px
                color #9C9C9C
            }
            .mla-form {
                background #FCFCFC
                box-shadow 0 9px 50px rgba(0, 0, 0, 0.05)
                width calc(100% - 160px)
                margin 0 auto
                padding-left 85px
                padding-top 65px
                padding-right 45px
                padding-bottom 45px
                margin-bottom 35px
                .mla-form-title {
                    width 100%
                    font-size 36px
                    color #167ADA
                    position relative
                    display flex
                    justify-content space-between
                    margin-bottom 50px
                }
                .mla-form-title div {
                    width calc(100% - 210px)
                    height 30px
                    border-bottom 1px solid #707070
                }
                .code-button {
                    height 50px
                    line-height 50px
                    font-size 22px
                    margin-left 10px
                }
                .iframe-style {
                    width 100%
                    height 0
                }
                .iframe-style-large {
                    width 100%
                    height 500px
                }
            }
            .cus-button {
                width 370px
                height 80px
                line-height 75px
                font-size 36px
                border-radius 35px
            }
            .mla-form >>> .ant-form-item-label > label {
                font-size 28px
                color #000
            }
            .mla-form >>> .ant-input {
                height 50px
                line-height 50px
                font-size 22px
            }
            .mla-form >>> .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
                height 50px
                line-height 50px
                font-size 22px
                padding 8px 11px
            }
            .mla-form >>> .ant-form-item-label {
                line-height 50px
            }
        }
    }
</style>
